export default (() => ({
  customDaysContainer: {
    width: '100%'
  }
}));
